import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "../../../../Component/CSS/SearchFilterStyle.css";

class SearchForm extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div style={{ fontSize: 16 }}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="searchCategoryName"
            type="text"
            label="Category Name"
            margin="normal"
            variant="outlined"
            fullWidth
            style={{ outline: "none" }}
            placeholder="Search by category name"
            InputProps={{
              classes: {
                root: classes.inputroot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.props.search.searchCategoryName}
            onChange={this.props.handleSearch}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchForm);
